exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".panel-heading h4[data-v-7fbd8d8a]{text-transform:uppercase;font-weight:500}[dir=ltr] .panel-heading h4[data-v-7fbd8d8a]{margin-left:-20px;padding-left:10px}[dir=rtl] .panel-heading h4[data-v-7fbd8d8a]{margin-right:-20px;padding-right:10px}.panel-flat[data-v-7fbd8d8a]{overflow-x:hidden!important}[dir] .address-card[data-v-7fbd8d8a]{background-color:#ffebee;border:1px solid #ffcdd2;border-radius:8px;padding:12px}.address-card-title[data-v-7fbd8d8a]{font-weight:700;font-size:15px}[dir] .address-card-title[data-v-7fbd8d8a]{margin-bottom:8px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7fbd8d8a","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/customer/addNewShipOnly.vue
// module id = 969
// module chunks = 0